import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { useParams, Link, useHistory } from "react-router-dom";
import { ToastBottomEnd } from "./Toast";
import {
    toastAddErrorMessageConfig,
    toastAddSuccessMessageConfig,
    toastEditErrorMessageConfig,
    toastEditSuccessMessageConfig,
    toastErrorMessageWithParameterConfig
} from "../../config/toastConfig";
import appConfig from "../../config/appConfig";
import { ERROR_401 } from "../../config/errorPage";
import { verifyPermission } from "../../helpers/permission";
import InputRequire from "./InputRequire";
import { verifyTokenExpire } from "../../middleware/verifyToken";
import { useTranslation } from "react-i18next";

const UnfoundedReasonForm = (props) => {
    const { t, ready } = useTranslation();
    const { id } = useParams();
    const history = useHistory();

    if (!id) {
        if (!verifyPermission(props.userPermissions, 'store-unfounded-reasons'))
            window.location.href = ERROR_401;
    } else {
        if (!verifyPermission(props.userPermissions, 'update-unfounded-reasons'))
            window.location.href = ERROR_401;
    }

    const defaultData = {
        libelle: {
            fr: "",
            en: ""
        }
    };

    const defaultError = {
        libelle: [],
        "libelle.fr": [],
        "libelle.en": []
    };

    const [data, setData] = useState(defaultData);
    const [error, setError] = useState(defaultError);
    const [startRequest, setStartRequest] = useState(false);

    useEffect(() => {
        async function fetchData() {
            if (id) {
                await axios.get(`${appConfig.apiDomaine}/unfounded-reasons/${id}`)
                    .then(response => {
                        const libObj = response.data.libelle || {};
                        setData({
                            libelle: {
                                fr: typeof libObj === "object" ? (libObj.fr || "") : libObj,
                                en: typeof libObj === "object" ? (libObj.en || "") : ""
                            }
                        });
                    })
                    .catch(() => {});
            }
        }
        if (verifyTokenExpire()) fetchData();
    }, [id]);

    const onChangeLibelleFr = (e) => {
        setData({
            ...data,
            libelle: { ...data.libelle, fr: e.target.value }
        });
    };

    const onChangeLibelleEn = (e) => {
        setData({
            ...data,
            libelle: { ...data.libelle, en: e.target.value }
        });
    };

    const onSubmit = (e) => {
        e.preventDefault();
        setStartRequest(true);

        if (verifyTokenExpire()) {
            const endpoint = id 
                ? `${appConfig.apiDomaine}/unfounded-reasons/${id}`
                : `${appConfig.apiDomaine}/unfounded-reasons`;
            const method = id ? 'put' : 'post';

            // Envoi de la valeur sous forme de chaîne de caractères pour passer la règle de validation
            const payload = {
                libelle: data.libelle.fr || data.libelle.en
            };

            axios[method](endpoint, payload)
                .then(() => {
                    setStartRequest(false);
                    setError(defaultError);
                    if (id) {
                        ToastBottomEnd.fire(toastEditSuccessMessageConfig());
                    } else {
                        setData(defaultData);
                        ToastBottomEnd.fire(toastAddSuccessMessageConfig());
                    }
                    history.push("/settings/unfounded-reasons");
                })
                .catch(errorRequest => {
                    setStartRequest(false);
                    if (errorRequest.response && errorRequest.response.data) {
                        const apiErrors = errorRequest.response.data.errors || errorRequest.response.data.error || {};
                        
                        // Si le message d'erreur est renvoyé sous la clé 'libelle', on le mappe
                        if (typeof apiErrors === "object") {
                            setError({ ...defaultError, ...apiErrors });
                        }
                        
                        ToastBottomEnd.fire(id ? toastEditErrorMessageConfig() : toastAddErrorMessageConfig());
                    }
                });
        }
    };

    const libelleError = error.libelle || error["libelle.fr"] || [];

    return ready ? (
        <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor" id="kt_content">
            <div className="kt-subheader kt-grid__item" id="kt_subheader">
                <div className="kt-container kt-container--fluid">
                    <div className="kt-subheader__main">
                        <h3 className="kt-subheader__title">{t("Paramètres")}</h3>
                        <span className="kt-subheader__separator kt-hidden" />
                        <div className="kt-subheader__breadcrumbs">
                            <a href="#home" className="kt-subheader__breadcrumbs-home"><i className="flaticon2-shelter" /></a>
                            <span className="kt-subheader__breadcrumbs-separator" />
                            <Link to="/settings/unfounded-reasons" className="kt-subheader__breadcrumbs-link">
                                {t("Motifs de non-fondé")}
                            </Link>
                            <span className="kt-subheader__breadcrumbs-separator" />
                            <a href="#button" onClick={e => e.preventDefault()} className="kt-subheader__breadcrumbs-link" style={{ cursor: "text" }}>
                                {id ? t("Modification") : t("Ajout")}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
                <div className="row">
                    <div className="col">
                        <div className="kt-portlet">
                            <div className="kt-portlet__head">
                                <div className="kt-portlet__head-label">
                      b1              <h3 className="kt-portlet__head-title">
                                        {id ? t("Modification d'un motif de non-fondé") : t("Ajout d'un motif de non-fondé")}
                                    </h3>
                                </div>
                            </div>
                            <form method="POST" className="kt-form" onSubmit={onSubmit}>
                                <div className="kt-portlet__body">
                                    <div className={libelleError.length ? "form-group row validated" : "form-group row"}>
                                        <label className="col-xl-3 col-lg-3 col-form-label" htmlFor="libelle_fr">
                                            {t("Libellé du motif")} <InputRequire />
                                        </label>
                                        <div className="col-lg-9 col-xl-6">
                                            <input
                                                id="libelle_fr"
                                                type="text"
                                                className={libelleError.length ? "form-control is-invalid" : "form-control"}
                                                placeholder={t("Veuillez entrer le motif du déclassement non fondé")}
                                                value={data.libelle.fr}
                                                onChange={onChangeLibelleFr}
                                            />
                                            {libelleError.map((err, idx) => (
                                                <div key={idx} className="invalid-feedback">{err}</div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="kt-portlet__foot">
                                    <div className="kt-form__actions text-right">
                                        {!startRequest ? (
                                            <button type="submit" className="btn btn-primary">
                                                {id ? t("Modifier") : t("Enregistrer")}
                                            </button>
                                        ) : (
                                            <button className="btn btn-primary kt-spinner kt-spinner--left kt-spinner--md kt-spinner--light" type="button" disabled>
                                                {t("Chargement")}...
                                            </button>
                                        )}
                                        <Link to="/settings/unfounded-reasons" className="btn btn-secondary mx-2">
                                            {t("Quitter")}
                                        </Link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ) : null;
};

const mapStateToProps = state => ({
    userPermissions: state.user.user.permissions,
    plan: state.plan.plan
});

export default connect(mapStateToProps)(UnfoundedReasonForm);